import { VelocityClient } from '@velocity-exchange/sdk';
import { PublicKey } from '@solana/web3.js';
import { createSwiftAccountIx } from '@velocity-exchange/common';
import { notify } from './notifications';
import { UiEnhancedIWalletV2 } from 'src/utils/wallets/IWalletV2';
import { FeePayerError } from 'src/constants/errors/FeePayerError';

export function getEffectiveTypeTimeoutMultiplier(
	effectiveType: 'slow-2g' | '2g' | '3g' | '4g' | undefined
): number {
	if (
		effectiveType === '3g' ||
		effectiveType === 'slow-2g' ||
		effectiveType === '2g'
	)
		return 1.5;
	return 1;
}

export const initializeSignedMsgUserOrdersAccount = async (
	driftClient: VelocityClient,
	authority: PublicKey,
	wallet: UiEnhancedIWalletV2,
	fallbackWallet?: UiEnhancedIWalletV2 | null
): Promise<boolean> => {
	const toastId =
		'swift-toggle-on-toast-' + Date.now() + '-' + authority.toBase58();
	notify({
		message: 'Enabling gasless trading...',
		type: 'info',
		id: toastId,
	});
	try {
		const { ix } = await createSwiftAccountIx({
			velocityClient: driftClient,
			authority,
		});

		const doInit = async (signer: UiEnhancedIWalletV2) => {
			await signer.signAndSendTransaction(ix);
		};

		try {
			await doInit(wallet);
		} catch (e) {
			if (e instanceof FeePayerError && fallbackWallet) {
				await doInit(fallbackWallet);
			} else {
				throw e;
			}
		}

		notify({
			message: 'Gasless trading enabled',
			description: 'You can disable gasless trading from the settings button',
			type: 'success',
			id: toastId,
		});
		return true;
	} catch (error) {
		console.error(error);
		notify({
			message: 'Failed to enable gasless trading',
			type: 'error',
			id: toastId,
		});
		return false;
	}
};
